import { render, staticRenderFns } from "./renovateRecord.vue?vue&type=template&id=7390aaa0&scoped=true"
import script from "./renovateRecord.vue?vue&type=script&lang=js"
export * from "./renovateRecord.vue?vue&type=script&lang=js"
import style0 from "./renovateRecord.vue?vue&type=style&index=0&id=7390aaa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390aaa0",
  null
  
)

export default component.exports